/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndadocument2Inputs */

const en_coinvestments_ndadocument2 = /** @type {(inputs: Coinvestments_Ndadocument2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA document`)
};

/**
* | output |
* | --- |
* | "NDA document" |
*
* @param {Coinvestments_Ndadocument2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndadocument2 = /** @type {((inputs?: Coinvestments_Ndadocument2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndadocument2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndadocument2(inputs)
});
export { coinvestments_ndadocument2 as "coInvestments_ndaDocument" }